import { extend, override } from "flarum/extend";
import Post from "flarum/components/Post";
import Button from "flarum/components/Button";
import icon from "flarum/helpers/icon";
import CommentPost from "flarum/components/CommentPost";
import DiscussionPage from "flarum/forum/components/DiscussionPage";
import ResponseItemsBtn from "flarum/common/components/ResponseItemsBtn";
import app from "flarum/forum/app";
import CommentModal from "flarum/forum/dianLiang/CommentModal";

export default function MakeTree() {
  override(Post.prototype, "config", function () {
    const $actions = this.$(".Post-actions");
    const $controls = this.$(".Post-controls");

    $controls.on("click tap", function () {
      $(this).toggleClass("open");
    });
  });
  extend(Post.prototype, "oninit", function (vdom) {
    this.id = this.attrs.post.id();
    if (!app.cache.trees) {
      app.cache.trees = {};
      app.cache.pushTree = {};
    }
    if (!app.cache.trees[this.id]) {
      app.cache.trees[this.id] = [];
      app.cache.pushTree[this.id] = 0;
    }
    this.count = app.cache.trees[this.id].length
      ? app.cache.trees[this.id].length
      : this.attrs.post.replyCount();

    this.include =
      "replyToUser,replyToUser.user,replyToPost,replyToPost.user,user,user.groups,editedUser,hiddenUser,discussion,discussion.user,discussion.user.userLevel,discussion.user.userLevel.levelConf,user.userLevel,user.userLevel.levelConf,likes,";

    if (this.count > 0 ) {
      app.store
        .find("trees", this.id, {
          include: this.include.replace(/,\s*$/, ""),
          page: { offset: 0, limit: 20 },
        })
        .then((response) => {
          delete response.payload;
          // [].push.apply(app.cache.trees[id], response);
          if (app.cache.trees[this.id].length !== response.length) {
            app.cache.trees[this.id] = response;
            m.redraw();
          }
        });
    }
  })
  extend(Post.prototype, "view", function (vdom) {
    if (app.cache.trees[this.id].length > 0) {
      vdom.children.push(
        <div className="CommentTree CommentTree-lin" id={this.id}>
          {icon("fas fa-reply")}
          {app.cache.trees[this.id]
            .filter(
              (thing, index, self) =>
                self.findIndex((t) => t.id() === thing.id()) === index
            )
            .sort((a, b) => {
              return b.createdAt() - a.createdAt();
            })
            .slice(0, 2)
            .map((post) => {
              return CommentPost.component({ post });
            })}
        </div>
      );
    }
    // if (this.attrs.post.replyCount() > app.cache.trees[id].length - app.cache.pushTree[id] || (app.cache.trees[id].length !== 0 && this.attrs.post.replyCount())) {
    if (app.cache.trees[this.id].length > 2) {
      if (app.initializers.has("fof-gamification")) {
        this.include += "user.ranks,upvotes,";
      }
      if (app.initializers.has("fof/reactions")) {
        this.include += "reactions";
      }
      vdom.children.push(
        Button.component(
          {
            className: "Button Button--link Evergreen--show",
            icon: "fas fa-caret-down",
            // onclick: () => {
            //   app.store.find('trees', id, {include: include.replace(/,\s*$/, "")})
            //     .then(response => {
            //       delete response.payload;
            //       [].push.apply(app.cache.trees[id], app.cache.treesList.slice(app.cache.treesLength,app.cache.treesLength+=10));
            //       // [].push.apply(app.cache.trees[id], response);
            //       m.redraw();
            //     })
            // }
            onclick: () =>
              app.modal.show(CommentModal, {
                id: this.id,
                count: app.cache.trees[this.id].length,
              }),
          },
          app.translator.trans("dl-tree.forum.all_responses", { count: app.cache.trees[this.id].length })
        )
      );
    }
  });
}
